export default __webpack_public_path__ + "d7e4014b837557718c8f18c822235c1f.svg";